import { forwardRef, type Ref, type SVGProps } from "react";
const IconEditFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="m19 7.3-16 16a1 1 0 0 0-.14.17l-.08.17a.6.6 0 0 0-.07.23l-.71 5A1 1 0 0 0 3 30h.14l5-.71a1 1 0 0 0 .41-.16l.17-.13 16-16zm10.7-.72L25.42 2.3a1 1 0 0 0-.71-.3 1 1 0 0 0-.72.3l-3.56 3.57 5.71 5.71L29.7 8a1 1 0 0 0 0-1.42" /></svg>;
const ForwardRef = forwardRef(IconEditFilledSVG);
ForwardRef.displayName = "IconEditFilled";
export { ForwardRef as IconEditFilled };